// extracted by mini-css-extract-plugin
module.exports = {"logoTitle":"LogoTitle_logoTitle__2VXCY","title":"LogoTitle_title__1ZLqN","logo":"LogoTitle_logo__3AqJk"};